import { createAsyncThunk } from '@reduxjs/toolkit';
import { EmailTemplatesApi } from '../../../api/base/EmailTemplates';

export const fetchEmailTemplates = createAsyncThunk(
  'emailTemplates/fetchEmailTemplates',
  async (): Promise<Array<any>> => {
    const response = await EmailTemplatesApi.getEmailTemplates();
    return response.data.data;
  },
);
